export default {
  MULTI: {
    SELECT: 'SELECT_MULTI_NODE',
    DELETE: {
      REQUEST: 'REQUEST_DELETE_MULTI_NODE',
      RECEIVE: 'RECEIVE_DELETE_MULTI_NODE',
      FAIL: 'FAIL_DELETE_MULTI_NODE',
      NOTIFY: 'NOTIFY_DELETE_MULTI_NODE'
    },
    PIN: 'PIN_MULTI_NODE',
    UNPIN: 'UNPIN_MULTI_NODE',
    MERGE: 'MERGE_MULTI_NODE'
  },
  ONE: {
    START_EDITING: 'START_EDITING_ONE_NODE',
    STOP_EDITING: 'STOP_EDITING_ONE_NODE',
    SELECT: 'SELECT_ONE_NODE',
    DESELECT: 'DESELECT_ONE_NODE',
    CREATE: {
      REQUEST: 'REQUEST_CREATE_ONE_NODE',
      RECEIVE: 'RECEIVE_CREATE_ONE_NODE',
      FAIL: 'FAIL_CREATE_ONE_NODE',
      NOTIFY: 'NOTIFY_CREATE_ONE_NODE'
    },
    EDIT: {
      REQUEST: 'REQUEST_EDIT_ONE_NODE',
      RECEIVE: 'RECEIVE_EDIT_ONE_NODE',
      FAIL: 'FAIL_EDIT_ONE_NODE',
      NOTIFY: 'NOTIFY_EDIT_ONE_NODE'
    },
    DELETE: {
      REQUEST: 'REQUEST_DELETE_ONE_NODE',
      RECEIVE: 'RECEIVE_DELETE_ONE_NODE',
      FAIL: 'FAIL_DELETE_ONE_NODE',
      NOTIFY: 'NOTIFY_DELETE_ONE_NODE'
    },
    PIN: 'PIN_ONE_NODE',
    UNPIN: 'UNPIN_ONE_NODE'
  }
}
